import _ from 'lodash';
import React from 'react';
import Input from '../common/input/input';
import ToggleSwitch from '../common/toggle-switch/toggle-switch';
// import TransparentInput from '../common/transparent-input/transparent-input';
import {
  JsonEditorWithToolbar,
  JsonEditorWithToolbarProps,
} from '../json-editor-with-toolbar/json-editor-with-toolbar';
import { JsonEditor, JsonEditorProps } from '../json-editor/json-editor';

import {
  // Checkbox,
  Dropdown,
  DropdownLayoutOption,
  FormField,
  MultiSelectCheckbox,
} from '@wix/design-system';
import { Editor } from 'codemirror';
import { FieldRenderProps, FormProps } from 'react-final-form';

interface InputProps {
  disabled?: boolean;
  id?: string;
  maxLength?: number;
  placeholder?: string;
  label?: React.ReactNode;
  readOnly?: boolean;
  dataHook?: string;
  size?: string;
  type?: string;
}

// export class FormInput extends React.Component<InputProps & FormProps> {
//   public render() {
//     const {
//       input: { onBlur, onChange, onFocus, value },
//       meta: { error, touched },
//     } = this.props;
//
//     return (
//       <Input
//         {...this.props}
//         onBlur={onBlur}
//         onChange={onChange}
//         onFocus={onFocus}
//         value={value}
//         status={touched && Boolean(error) && 'error'}
//         statusMessage={error}
//       />
//     );
//   }
// }

interface InputWithLabelControlProps extends InputProps {
  autoFocus?: boolean;
  className?: string;
  labelClassName?: string;
  label?: string;
}

export const ERROR_MARKER_NOT_FOR_USER = 'error';

export const FormInputWithLabelControl = (
  props: FieldRenderProps<{ props: InputWithLabelControlProps }>,
) => {
  const {
    input: { onBlur, onChange, onFocus, value },
    meta: { error, touched },
    disabled,
    id,

    dataHook,
    placeholder,
  } = props;

  const { autoFocus, label } = props;
  const hasError = touched && Boolean(error);
  const errorMessage =
    hasError &&
    ((typeof error === 'string' && error !== ERROR_MARKER_NOT_FOR_USER) ||
      _.isObject(error))
      ? error
      : undefined;

  return (
    <FormField label={label}>
      <Input
        id={id}
        size="small"
        autoFocus={autoFocus || false}
        disabled={disabled}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        value={value}
        status={(touched && Boolean(error) && 'error') || undefined}
        statusMessage={errorMessage}
        placeholder={placeholder}
        dataHook={dataHook}
      />
    </FormField>
  );
};

// type FormTransparentInputProps = FormProps & {
//   className?: string;
//   id?: string;
//   placeholder?: string;
// };

// export class FormTransparentInput extends React.Component<FormTransparentInputProps> {
//   public render() {
//     const {
//       input: { onBlur, onChange, onFocus, value },
//       meta: { error, touched },
//     } = this.props;
//
//     return (
//       <TransparentInput
//         {..._.omit(this.props, ['input', 'meta', 'dataHook'])}
//         onBlur={onBlur}
//         onChange={onChange}
//         onFocus={onFocus}
//         value={value}
//         error={touched && Boolean(error)}
//       />
//     );
//   }
// }

type FormDropdownProps = FormProps & any;

export const FormDropdown = (props: FormDropdownProps) => {
  const {
    input: { onChange, value },
    meta: { error, touched },
  } = props;

  return (
    <Dropdown
      popoverProps={{
        appendTo: 'scrollParent',
        dynamicWidth: true,
      }}
      {...props}
      onSelect={(opt) => onChange(opt.id)}
      initialSelectedId={value}
      status={(touched && Boolean(error) && 'error') || undefined}
    />
  );
};

// interface FormCheckboxProps {
//   checkboxValue?: string;
//   label?: string | JSX.Element;
//   id?: string;
// }
//
// interface FormCheckboxState {
//   checked: boolean;
// }

// export class FormCheckbox extends React.Component<
//   FormProps & FormCheckboxProps,
//   FormCheckboxState
// > {
//   public state: FormCheckboxState;
//
//   constructor(props: FormProps & FormCheckboxProps) {
//     super(props);
//
//     this.state = {
//       checked: props.checkboxValue === props.input.value,
//     };
//   }
//
//   public UNSAFE_componentWillReceiveProps(
//     nextProps: FormProps & FormCheckboxProps,
//   ) {
//     this.setState({
//       checked: nextProps.input.value === this.props.checkboxValue,
//     });
//   }
//
//   public onChange(event: React.ChangeEvent<HTMLInputElement>) {
//     const { input, checkboxValue } = this.props;
//     event.target.checked ? input.onChange(checkboxValue) : input.onChange(null);
//
//     this.setState({
//       checked: event.target.checked,
//     });
//   }
//
//   public render() {
//     const {
//       meta: { error, touched },
//       label,
//       id,
//     } = this.props;
//
//     return (
//       <Checkbox
//         key={id}
//         checked={this.state.checked}
//         onChange={this.onChange.bind(this)}
//         hasError={touched && error}
//       >
//         {label}
//       </Checkbox>
//     );
//   }
// }

interface FormToggleSwitchProps {
  disabled: boolean;
}

export class FormToggleSwitch extends React.Component<
  FieldRenderProps<FormToggleSwitchProps>,
  {}
> {
  public render() {
    const {
      disabled,
      input: { value },
    } = this.props;

    return (
      <ToggleSwitch
        size="medium"
        checked={Boolean(value)}
        disabled={disabled}
        dataHook="form-toggle-switch"
        onChange={this.handleChange.bind(this)}
      />
    );
  }

  private handleChange() {
    const {
      input: { onChange: toggleChange, value },
      onChange,
    } = this.props;
    toggleChange(!value);
    onChange(Boolean(!value), Boolean(value));
  }
}

interface FormMultiSelectCheckboxProps {
  dataHook?: string;
  options?: DropdownLayoutOption[];
  noLeftBorderRadius?: boolean;
  noRightBorderRadius?: boolean;
}

export const FormMultiSelectCheckbox: React.FunctionComponent<
  FormMultiSelectCheckboxProps & FieldRenderProps<any>
> = (props) => {
  const {
    dataHook,
    input: { onChange, value },
    noLeftBorderRadius,
    noRightBorderRadius,
  } = props;

  const options = props?.props?.options || props.options || undefined;

  let selectedOptions = [];

  if (value) {
    selectedOptions = value;
  }

  return (
    <MultiSelectCheckbox
      dataHook={dataHook}
      onSelect={(id: string) => onChange([...selectedOptions, id])}
      onDeselect={(id: string) => onChange(_.pull(selectedOptions, id))}
      options={options}
      selectedOptions={selectedOptions}
      noRightBorderRadius={noRightBorderRadius}
      noLeftBorderRadius={Boolean(noLeftBorderRadius)}
    />
  );
};

export const FormJsonEditor: React.FunctionComponent<
  FieldRenderProps<JsonEditorProps>
> = (props) => {
  const {
    meta: { error, touched, initial },
    input: { onChange, onBlur },
  } = props;

  const isFlowJson = JSON.parse(initial?.toString()).hasOwnProperty('flow');

  return (
    <JsonEditor
      {..._.omit(props.props, ['input', 'meta', 'label'])}
      json={isFlowJson ? '' : initial?.toString()}
      placeholder={initial?.toString()}
      error={touched && Boolean(error)}
      onChange={onChange}
      onBlur={(_editor: Editor) => {
        onBlur();
      }}
    />
  );
};

export const FormJsonEditorWithToolbar: React.FunctionComponent<
  FieldRenderProps<JsonEditorWithToolbarProps>
> = (props) => {
  const {
    meta: { error, touched, initial },
    input: { onChange, onBlur },
  } = props;

  // Do not handle onChange event here to improve performance. Only handle onBlur.
  return (
    <JsonEditorWithToolbar
      {..._.omit(props, ['input', 'meta', 'label'])}
      json={initial?.toString()}
      error={touched && Boolean(error)}
      onChange={onChange}
      onBlur={(_editor: Editor) => {
        onBlur();
      }}
    />
  );
};
